"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const logic_types_1 = require("../logic-types");
class Card {
    get isFaceUp() {
        return this.faceUp;
    }
    get isHidden() {
        return this.hidden;
    }
    get cardId() {
        return this.cardIndexMapping.cardIdForIndex(this.index);
    }
    constructor(index, cardIndexMapping, faceUp, hidden) {
        this.index = index;
        this.cardIndexMapping = cardIndexMapping;
        this.faceUp = faceUp;
        this.hidden = hidden;
    }
    clone() {
        return new Card(this.index, this.cardIndexMapping, this.isFaceUp, this.isHidden);
    }
    openCard() {
        this.faceUp = true;
        this.hidden = false;
    }
    openHidden() {
        this.hidden = true;
    }
    closeCard() {
        this.faceUp = false;
    }
    displayDescription() {
        const id = this.cardId;
        if (!id) {
            return "|🤔 ?|";
        }
        let suit = "🤷";
        switch (id.cardSuit) {
            case logic_types_1.CardSuit.Club:
                suit = "♣️";
                break;
            case logic_types_1.CardSuit.Diamond:
                suit = "♦️";
                break;
            case logic_types_1.CardSuit.Heart:
                suit = "♥️";
                break;
            case logic_types_1.CardSuit.Spade:
                suit = "♠️";
                break;
        }
        return `|${suit} ${id.stringType}|`;
    }
    setStatusWhenNone(status) {
        this.cardIndexMapping.setStatusWhenNoneForIndex(this.index, status);
    }
    setStatusWhenPendingHidden(status) {
        this.cardIndexMapping.setStatusWhenPendingHiddenForIndex(this.index, status);
    }
}
exports.Card = Card;
